import { render, staticRenderFns } from "./WidgetTextMetadata.vue?vue&type=template&id=57b15e53&"
import script from "./WidgetTextMetadata.vue?vue&type=script&lang=js&"
export * from "./WidgetTextMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetTextMetadata.vue"
export default component.exports